<div class="content_container">
    <div class="logo_container">
      <a routerLink="/">
        <img src="../../../assets/AMADEO LOGO 2.png" class="logo">
      </a>
    </div>
    <div class="page_title">IMPRESSUM</div>
   
    <div class="text_container">
        <div class="text-block">
            <div>CEO: Ing. Michael Makivic</div>
            <div>Company ID: FN 422987s</div>
            <div>UID: ATU69099423</div>
        </div>
        <div class="text-block">
            <div>based in</div>
            <div>Skrabalgasse 8, 1220 Vienna, Austria</div>
        </div>
        <div class="text-block">
            <div>email: office@amadeosystems.com</div>
            <div>phone: +43 1 269 63 28 - 0</div>
        </div>
        <div class="text-block">
            <div>www.amadeosystems.com</div>
        </div>
    </div>

    
</div>